var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-font"},[(_vm.index === 0)?_c('span',[_vm._v(_vm._s(_vm.itemLabel))]):_vm._e(),(_vm.index === 1)?_c('span',{staticClass:"grey--text caption ml-1"},[_vm._v(" (+"+_vm._s(_vm.totalItems - 1)+") ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }